import { makeAutoObservable } from 'mobx';
import castArray from 'lodash/castArray';

import type { InformedConsentFileData, Optional, RenderedServiceData } from 'chaika-frontend-types/frontend-cms';

import { RenderedServiceList } from '@store/RenderedService/RenderedServiceList';

export class ServiceInformedConsentStore {
    private renderedServiceInformedConsents: Map<string, InformedConsentFileData> = new Map();
    private renderedServiceList: RenderedServiceList = new RenderedServiceList();

    constructor() {
        makeAutoObservable(this, undefined, { autoBind: true });
    }

    public get filesCount(): number {
        return this.renderedServiceInformedConsents.size;
    }

    public set(renderedServiceInformedConsents: InformedConsentFileData[]): void {
        this.renderedServiceInformedConsents = new Map(
            renderedServiceInformedConsents.map(it => [it.renderedServiceId, it]),
        );
    }

    public add(renderedServiceInformedConsents: InformedConsentFileData | InformedConsentFileData[]): void {
        castArray(renderedServiceInformedConsents).forEach(it => {
            this.renderedServiceInformedConsents.set(it.renderedServiceId, it);
        });
    }

    public get(renderedServiceId: string): Optional<InformedConsentFileData> {
        return this.renderedServiceInformedConsents.get(renderedServiceId);
    }

    public getAll(): InformedConsentFileData[] {
        return Array.from(this.renderedServiceInformedConsents.values());
    }

    public delete(renderedServiceId: string): void {
        this.renderedServiceInformedConsents.delete(renderedServiceId);
    }

    public getRenderedServices(): RenderedServiceData[] {
        return this.renderedServiceList.values;
    }

    public addRenderedServices(renderedServices: RenderedServiceData[]): void {
        this.renderedServiceList.add(renderedServices);
    }

    public hasInformedConsentForRenderedService(renderedServiceId: string): boolean {
        return this.renderedServiceInformedConsents.has(renderedServiceId);
    }

    public everyRenderedServiceHasInformedConsent(entryId: string, serviceId: string): boolean {
        return this.getRenderedServices()
            .filter(it => it.entryId === entryId && it.serviceId === serviceId)
            .every(it => this.hasInformedConsentForRenderedService(it.id));
    }
}

export const serviceInformedConsentStore = new ServiceInformedConsentStore();
